<template>
  <!-- Breadcrumbs -->
  <div class="px-[16px] p-[12px] bg-off-white">
    <ul class="breadcrumbs__list gap-[10px]">
      <li class="breadcrumbs__item">
        <a class="breadcrumbs__link" href="/">
          <img :alt="in18['page_home']" class="img" src="/shop/images/breadcrumbs-home.svg">
        </a>
      </li>
      <li v-for="parent in category.parents" v-if="category.parents" class="breadcrumbs__item ">
        <a :href="parent.link" :title="parent.title">
          {{ parent.title }}
        </a>
      </li>
    </ul>
  </div><!-- .breadcrumbs -->
</template>

<script>
export default {
  props: {
    in18:     Object,
    category: Object,
  },
};
</script>
